export const SNOWPACK_PUBLIC_COMMIT_HASH = "92c9fd0f86fb4bce7b7b8d7067c1220f9a51640b";
export const SNOWPACK_PUBLIC_GIT_BRANCH = "HEAD";
export const SNOWPACK_PUBLIC_APP_VERSION = "131";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;